module.exports = __webpack_public_path__ + "img/icons BFr_39.8d74c234.svg";